import React from 'react'
import AdminEventList from './AdminEventList'
import { EventsContainer } from '../styles'

const AdminEvent = () => {
	return (
		<EventsContainer>
			<AdminEventList />
		</EventsContainer>
	)
}

export default React.memo(AdminEvent)
